export type MessageFeedbackRating = 'up' | 'down';

// Declaration order is the chip render order in the composer.
export enum MessageFeedbackCategory {
  WRONG_INFO = 'wrong_info',
  SHOULD_NOT_HAVE_SENT = 'should_not_have_sent',
  NOT_MY_VOICE = 'not_my_voice',
  FORMATTING_BUG = 'formatting_bug',
  MISSED_THE_QUESTION = 'missed_the_question',
}

/**
 * Reason chips offered on thumbs-down. Each one maps to a distinct failure mode of the reply, so the
 * labels stay mutually exclusive and can be used as-is as eval labels.
 */
export const messageFeedbackCategoryLabels: Record<MessageFeedbackCategory, string> = {
  [MessageFeedbackCategory.WRONG_INFO]: 'Wrong info',
  [MessageFeedbackCategory.SHOULD_NOT_HAVE_SENT]: `Shouldn't have sent`,
  [MessageFeedbackCategory.NOT_MY_VOICE]: 'Not my voice',
  [MessageFeedbackCategory.FORMATTING_BUG]: 'Formatting bug',
  [MessageFeedbackCategory.MISSED_THE_QUESTION]: 'Missed the question',
};

export interface MessageFeedbackDto {
  rating: MessageFeedbackRating;
  categories: MessageFeedbackCategory[];
  comment: string | null;
}

export interface SubmitMessageFeedbackPayload {
  messageId: number;
  rating: MessageFeedbackRating;
  categories?: MessageFeedbackCategory[];
  comment?: string | null;
}

export interface SubmitConversationFeedbackPayload {
  conversationId: string;
  comment: string;
}
